import { Appearance, PrintArea } from '@/types';
import { getPrintTypesOfAppearance } from '@/model/productType/getPrintTypesOfAppearance';

export const getPrintTypesForPrintArea = (printArea: PrintArea, appearance: Appearance) => {
  return getPrintTypesOfAppearance(appearance).filter(
    (pt) => !printArea.restrictions.excludedPrintTypes.some((ept) => ept.id === pt.id)
  );
};
